import * as React from "react";
import {FooterPayload} from "../contenful/types";
import {INLINES} from '@contentful/rich-text-types';
import './styles/FooterText.scss';
import {renderContentAsComponent} from "../contentutils";


interface Props {
    footer: FooterPayload;
}

export const richTextOptions = {
    renderNode: {
        [INLINES.ENTRY_HYPERLINK]: (node:any, next:any) => {
            if(node.data.target.fields) {
            return <a href={`/info/${node.data.target.fields.id}`}>{next}</a>
            } else {
                return <span style={{backgroundColor: 'red', color: 'white'}}> ENTRY HYPER </span>
            }
        }
    }
};

const FooterText: React.FC<Props> = ({footer}) => {
    return (
        <div className={"footerTextcontainer"}>
            {
                footer.text && (
                    renderContentAsComponent(footer.text as any, richTextOptions)
                )
            }
        </div>
    )
}

export default FooterText;

